import React from "react";
import { FORGET_PASSWORD_ENDUSER } from "../../constants/ApiPaths";
import {
  Button,
  Form,
  FormGroup,
  FormFeedback,
  Label,
  Input,
} from "reactstrap";
import { USER_SIGNIN } from "../../constants/RoutePaths";
import { Link } from "react-router-dom";
import {  getAuthAgencyId } from "../common/CommonFunctions";
import { authCustomerHeader } from "../../functions/CoreFunctions";

export default function CustomerSendOtp(props) {
  const {
    loading,
    setFlag,
    setLoading,
    enqueueSnackbar,
    useFormik,
    Yup,
    API,
    CustomButtonLoader,
    CustomAlertMessage,
    setEmail,
    agencyUrl,
  } = props;

  const initialValues = {
    email: "",
  };

  // validation schema
  const validationSchema = Yup.object().shape({
    email: Yup.string().email("Invalid email").required("Email Required"),
  });

  //formik
  const {
    handleSubmit,
    handleChange,
    values,
    handleBlur,
    errors,
    touched,
  } = useFormik({
    initialValues: initialValues,
    validationSchema,
    onSubmit: (values) => getOTP(values),
  });

  //for getting otp
  const getOTP = async (values) => {
    setLoading(true);
    const config = {
      method: "POST",
      url: FORGET_PASSWORD_ENDUSER,
      data: {...values,agencyId:getAuthAgencyId()},
      headers: authCustomerHeader(),
      
    };
    try {
      const response = await API(config);
      const { status, message } = response.data;
      if (status === "Success") {
        CustomAlertMessage(message, "success", enqueueSnackbar);
        setEmail(values.email);
        setFlag(false);
      }
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        CustomAlertMessage(data.message, "error", enqueueSnackbar);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <h4>Find Your Account</h4>
      <p className="mb-4">Enter your email to get an OTP</p>
      <Form form="true" onSubmit={handleSubmit}>
        <FormGroup>
          <Label for="exampleEmail">Email</Label>
          <Input
            type="email"
            onBlur={handleBlur}
            name="email"
            value={values.email}
            invalid={touched.email && errors.email ? true : false}
            onChange={handleChange}
            id="exampleEmail"
            placeholder="Enter your email"
          />
          <FormFeedback>
            {touched.email && errors.email ? errors.email : ""}
          </FormFeedback>
        </FormGroup>

        {/* Button */}
        <Button color="primary" block style={{marginBottom: '5px'}}>
          {loading && <CustomButtonLoader />}
          Send OTP
        </Button>
        <Link
          to={{
            pathname: `${USER_SIGNIN}/${agencyUrl}`,
            state: { agencyUrl: agencyUrl },
          }}
        >
          Sign in here.
        </Link>
      </Form>
    </div>
  );
}
